import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, FormArray, FormControl, Validators } from "@angular/forms";
import { Router, ActivatedRoute } from '@angular/router';
import { AuthService } from "../../login/shared/auth.service";
import { RoleService } from "../Shared/role.service";
import { PrivilegeService } from "../Shared/privilege.service";

@Component({
  selector: 'app-privilege',
  templateUrl: './privilege.component.html',
  styleUrls: ['./privilege.component.css']
})
export class PrivilegeComponent implements OnInit {

  addForm: FormGroup;
  btnvisibility: boolean = true;

  RoleNo: number;
  RoleList: any[] = [];
  DocumentList: any[] = [];
  ErrorText: string;

  constructor(private formBuilder: FormBuilder, private route: ActivatedRoute,
    private router: Router, private authService: AuthService,
    private roleService: RoleService, private privilegeService: PrivilegeService) { }

  ngOnInit() {
    this.route.params.subscribe(params => {
      this.RoleNo = +  params['Id'];
    });

    if (Number.isNaN(this.RoleNo)) {

      this.addForm = this.formBuilder.group({
        frmId: [0],
        frmRoleId: [0, Validators.required],
        frmActive: [true],
        frmFlag: [1],

        privilegeList: this.formBuilder.array([]),
        // skills: this.formBuilder.array([]),
      });

      this.GetRoleList();
      this.GetDocumentList();

      // this.addSkills();
    }
    else {
      // this.AddButtonText = "Edit & Save";
      // this.GetRolesById();
    }
  }


  onSubmit() {

    if (this.addForm.value.frmRoleId != 0) {
      this.privilegeService.IUDPrivilege(this.addForm.value).toPromise()
      // this.privilegeService.IUDPrivilege(this.addForm.value.privilegeList).toPromise()
        .then(data => {

          this.router.navigate(['/privilege']);
        })
    }
  }

  GetRoleList() {

    this.roleService.FetchRoleList().toPromise()
      .then(data => {
        this.RoleList = data;

      })
      .catch(err => { console.log(err) });
  }

  get privilegeList(): FormArray {
    return this.addForm.get("privilegeList") as FormArray;
  }

  // get skills(): FormArray {
  //   return this.addForm.get("skills") as FormArray
  // }

  // newSkill(): FormGroup {
  //   return this.formBuilder.group({
  //     skill: 'c#',
  //     exp: '2',
  //   })
  // }

  // addSkills() {
  //   this.skills.push(this.newSkill());
  // }

  newPrivilege(DocList: any): FormGroup {

    return this.formBuilder.group({
      RoleId: DocList.RoleId,
      DocumentId: DocList.DocumentId,
      DocumentName: DocList.DocumentName,
      IsMenu: DocList.IsMenu,
      IsView: DocList.IsView,
      IsAdd: DocList.IsAdd,
      IsEdit: DocList.IsEdit,
      IsDelete: DocList.IsDelete,
    })

    // return this.formBuilder.group({
    //   DocumentId : 121,
    //   DocumentName :'test',
    //   IsView : false,
    //   IsAdd :false,
    //   IsEdit :false,
    //   IsDelete :false,
    // })
  }

  GetDocumentList() {
    this.privilegeService.GetPrivilegeList().toPromise()
      .then(data => {
        this.DocumentList = data;
        //  this.privilegeList.push(this.newPrivilege());

        for (let document of this.DocumentList) {
          this.privilegeList.push(this.newPrivilege(document));
        }
      })
      .catch(err => { console.log(err) });
  }

  SelectPrivilegeByRole(RoleId: any){

    const control = <FormArray>this.addForm.controls['privilegeList'];
    for(let i = control.length-1; i >= 0; i--) {
        control.removeAt(i)
    }

    this.privilegeService.GetPrivilegebyRoleId(RoleId).toPromise()
    .then(data => {

      this.DocumentList = data;
      for (let document of this.DocumentList) {
        this.privilegeList.push(this.newPrivilege(document));
      }
    })
    .catch(err => { console.log(err) });
  }

}
